// plugins/event-bus.ts
import { defineNuxtPlugin } from '#app'
import mitt from 'mitt'

export default defineNuxtPlugin((nuxtApp) => {
  const emitter = mitt()

  // Provide $bus throughout the app
  nuxtApp.provide('bus', {
    emit: emitter.emit,   // emit events
    on: emitter.on,       // listen for events
    off: emitter.off      // stop listening
  })
})
